import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    color: white;
    align-items: center;
    justify-content: center;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 130%;
`

export const Icon = styled.img`
    margin-bottom: 20px;
`
